import React from "react";
import { isNil } from "lodash-es";

export const TrinaryTree = ({ branch, nullBranch, trueBranch, falseBranch }) => {
  if (isNil(branch)) {
    return <>{nullBranch}</>;
  }
  if (branch === true) {
    return <>{trueBranch}</>;
  }
  if (branch === false) {
    return <>{falseBranch}</>;
  }
};
